<template>
    <div>
        <input ref="upload" style="display: none" type="file" :multiple="false" @change="onChange" />
        <a-space>
            <a-button type="primary" :loading="loading" @click="onClick">
                {{ list.length > 0 ? '重新上传' : '点击上传' }}
            </a-button>
            <span style="color: #999">上传说明：支持.pdf和.docx格式的文件上传，文档的章节段落尽量结构清晰，pdf文件需要选择文字清晰的版本</span>
        </a-space>
    </div>
</template>
  
<script>
import { uploadFile } from "@/api/upload";
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        },
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        onClick() {
            this.$refs.upload.click();
        },

        onChange(e) {
            const files = e.target.files;
            const data = new FormData();
            for (let i = 0; i < files.length; i++) {
                data.append("file", files[i]);
            }

            this.$emit("change", data, files[0].name);
        },

    },
};
</script>